import s from './Header.module.scss'
import type { HeaderProps } from './Header.props'

export function Header({ data }: HeaderProps) {
  return (
    <div className={s.header}>
      <h1
        className={s.title}
        dangerouslySetInnerHTML={{ __html: data.title }}
      />
    </div>
  )
}
